import React from "react";
import { useFormContext } from "react-hook-form";
import AddCircleOutlineRoundedIcon from "@mui/icons-material/AddCircleOutlineRounded";
import { IMultipleUsersHelpers } from "repoV2/features/Common/modules/FormData/interfaces/MultipleUserHelpers.interfaces";
import useToastMessage from "repoV2/components/common/Toast/useToastMessage";
import { LISTING_TYPES } from "repoV2/features/Listing/Listing.constants";
import { checkout_form_error_strings } from "../CheckoutForm/CheckoutForm.constants";
import { useCheckoutBasicDetailsContext } from "../../../CheckoutBasicDetailsContextProvider";
import useAddNewUserDetails from "../FormGroups/modules/UserDetailsFormGroup/utils/useAddNewUserDetails";
import styles from "./AddNewUsersButton.module.scss";

const { submit_all } = checkout_form_error_strings;

const AddNewUsersButton = (props: {
    handleUserDetailsFormOpen: () => void;
    allUserIds: IMultipleUsersHelpers["allUserIds"];
}) => {
    const { handleUserDetailsFormOpen, allUserIds } = props;
    const { handleSubmit } = useFormContext();

    const { notify, toast_type_keys } = useToastMessage();

    const { listingType } = useCheckoutBasicDetailsContext();

    const { checkIsNewBatchValid } = useAddNewUserDetails();

    const handleAddNewUserClick = () => {
        handleSubmit(
            () => {
                // incase the listing is of type classes, we have to check if the number of users
                // is less than or equal to the allowed slots
                // incase not, we do not allow to add the user
                if (
                    (listingType === LISTING_TYPES.GROUP_CLASSES ||
                        listingType === LISTING_TYPES.ROLLING_CLASSES ||
                        listingType === LISTING_TYPES.ONE_ON_ONE_CLASSES) &&
                    !checkIsNewBatchValid({ allUserIds })
                ) {
                    return;
                }

                // continue to the user addition flow
                handleUserDetailsFormOpen();
            },
            () => {
                notify(submit_all, {
                    type: toast_type_keys.error,
                });
            }
        )();
    };

    return (
        <div className={styles.container} onClick={handleAddNewUserClick}>
            <AddCircleOutlineRoundedIcon className={styles.addNewUserIcon} />
            <div className={styles.addNewUserText}>Add another person</div>
        </div>
    );
};

export default AddNewUsersButton;
